import React, { useState, useEffect, useRef } from 'react';
import { ResponsiveContainer, ScatterChart, XAxis, YAxis, Tooltip, Scatter } from 'recharts';

function CustomScatterChart(props) {
    const chartRef = useRef(null);
    const [rectWidth, setRectWidth] = useState(45);
    const [rectHeght, setRectHeight] = useState(40);

    useEffect(() => {

        if (chartRef.current) {
            const chartWidth = chartRef.current.container.clientWidth;

            const newRectWidth = chartWidth / 24 * 0.75;

            if (newRectWidth < rectHeght) {
                setRectWidth(newRectWidth);
                setRectHeight(newRectWidth);
            } else {
                setRectWidth(rectHeght);
                setRectHeight(rectHeght);
            }
        }
    }, []);

    const renderCustomShape = (props) => {
        const { cx, cy, fill } = props;
        const radius = 4;

        return (
            <rect
                x={cx}
                y={cy}
                width={rectWidth}
                height={rectHeght}
                rx={radius}
                ry={radius}
                fill={fill}
            />
        );
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length > 0) {
            return (
                <div className="custom-chart-tooltip">
                    <h5>{payload[0].payload.date} :  {payload[0].payload.hour_from} - {payload[0].payload.hour_to}</h5>
                    <br />
                    <h3>{payload[0].payload.name}</h3>
                </div>
            );
        } else {
            return null;
        }
    }

    const CustomYTick = (props) => {
        const { x, y, payload } = props;

        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      
        return (
          <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={25} textAnchor="end" fill="#666">
              {days[payload.value - 1]}
            </text>
          </g>
        );
      };
    
    
    const colors = [...new Set(props.data.map(d => d.color))];
    const days = Array.from({ length: 7 }, (_, i) => i + 1);
    const hours = Array.from({ length: 24 }, (_, i) => i + 1);

    return (

        <ResponsiveContainer ref={chartRef} width="100%" height={400}>
            <ScatterChart margin={{ top: 20, right: 20, bottom: 10, left: 10 }}>
                <YAxis type="number" dataKey="day" tick={<CustomYTick />} ticks={days}/>
                <XAxis type="number" dataKey="hour" ticks={hours} />
                <Tooltip content={<CustomTooltip />} />
                {
                    colors.map((color) => {
                        return <Scatter data={props.data.filter(d => d.color === color)} fill={color} shape={renderCustomShape} />
                    })
                }
            </ScatterChart>
        </ResponsiveContainer>
    );
};

export default CustomScatterChart;